import { render } from "./MergeSegments.vue?vue&type=template&id=2b8ec754&scoped=true&ts=true"
import script from "./MergeSegments.vue?vue&type=script&lang=ts"
export * from "./MergeSegments.vue?vue&type=script&lang=ts"

import "./MergeSegments.vue?vue&type=style&index=0&id=2b8ec754&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b8ec754"]])

export default __exports__